<template>

  <!--new header-->
  <el-container>
    <el-header>
      <el-row type="flex">
        <el-col class="" :xs="13" :lg="20">
          <div>
            <img style="height:40px" src="@/assets/header/yippi-logo.png">
          </div>
        </el-col>

        <el-col :xs="7" :lg="2">
          <div class="bg-1" style=""><lang-switcher /></div>
        </el-col>

        <el-col class="" :xs="4" :lg="2">
          <div v-if="auth" class=" bg-2">
            <!-- <button class="logout" @click="onLogout">Logout</button> -->
            <el-dropdown class="" trigger="click">
              <div class="avatar-wrapper">

                <img v-if="avatarURL" :src="avatarURL" class="user-avatar">
                <img v-else :src="defaultAvatar" class="user-avatar">
                <i class="el-icon-caret-bottom" />
              </div>

              <el-dropdown-menu slot="dropdown">

                <el-dropdown-item disabled>
                  <span id="userSpan"> {{ userName }} </span>
                </el-dropdown-item>

                <el-dropdown-item disabled>
                  <img src="@/assets/header/yipps_coin/ic-16-yipps.png" srcset="@/assets/header/yipps_coin/ic-16-yipps@2x.png 2x,@/assets/header/yipps_coin/ic-16-yipps@3x.png 3x" class="ic_16_yipps">
                  &nbsp;&nbsp;<span id="currencySpan">{{ yippsCurrency }}</span>
                </el-dropdown-item>

                <el-dropdown-item divided>
                  <span style="color:#d0021b" @click="onLogout">{{ $t("headerVue.logout") }}</span>
                </el-dropdown-item>
              </el-dropdown-menu>

            </el-dropdown>

          </div>
        </el-col>

      </el-row>
    </el-header>
  </el-container>
<!--new header-->
</template>

<script>
import { mapGetters } from 'vuex'
import LangSwitcher from './LanguageSwitcher.vue'

export default {
  components: {
    'lang-switcher': LangSwitcher
  },
  data() {
    return {
      defaultAvatar: require('../../assets/header/img_avatar.png')
    }
  },
  computed: {
    ...mapGetters({
      auth: 'authStore/isAuthenticated',
      userName: 'authStore/getUserName',
      yippsCurrency: 'authStore/getYippsCurrency',
      avatarURL: 'authStore/getAvatarURL'

    })
  },
  methods: {
    onLogout() {
      this.$store.dispatch('authStore/logout')
    }
  }
}
</script>

<style scoped>

  ul {
    list-style: none;
    margin: 0;
    padding: 0;
    /* display: flex; */
    flex-flow: row;
    align-items: center;
    font-family: 'Montserrat';
    text-align: center;
  }

  li {
    margin: 0 16px 0 40px;
  }

  .ic_16_yipps {
  width: 14px;
  height: 14px;
  object-fit: contain;
  }

  /* .bg-1{
    background-color: burlywood;
  }

  .bg-2{
    background-color: palegreen;
  } */

  #userSpan{
    font-size: 16px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    text-align: center;
    color: #000000;
  }

  #currencySpan{
    font-size: 14px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #4a4a4a;
  }

  .divFlexEnd{
    display: flex;
    justify-content: flex-end;
  }

  .user-avatar {
    cursor: pointer;
    width: 45px;
    height: 45px;
    border-radius: 50%;
  }

  .el-icon-caret-bottom {
    cursor: pointer;
    position: absolute;
    right: -20px;
    top: 25px;
    font-size: 12px;
  }

</style>
